export function isMiniProgram() {
    return navigator.userAgent.toLowerCase().includes("miniprogram");
}

export function addMobileMeta() {
    // 添加 viewport meta
    const meta = document.createElement("meta");
    meta.name = "viewport";
    meta.content = "width=device-width, initial-scale=1.0";
    meta.dataset.myMeta = "m-miniprogram-webview"; // 自定义标识符
    document.head.appendChild(meta);

    // 强制触发视口更新, 立即生效且不影响初始布局
    window.dispatchEvent(new Event("resize"));
}

export function removeMobileMeta() {
    // 移除自定义的 viewport meta
    const meta = document.querySelector('meta[name="viewport"][data-my-meta="m-miniprogram-webview"]');
    if (meta) {
        document.head.removeChild(meta);
    }
}
